<template lang="pug">
  .container(v-if='items' id="ShortMediaList-container")
    .row(v-for="item in sortedItems", :key="item.id", :class="{ selected: isSelected(item) }", @click='toggleItemInSelected(item)', :id="'ShortMediaList-row' + item.id" )
      .img-container
        img.thumbnail(v-if="showThumbs && item.type !== 'Audio'", :src="getMediumThumbnailPath(getMediumById(item.id))", @click='playMedium(item)')
      MediumIcon.icon(v-if='showMediaIcons', :medium='item')
      span.medium-name {{item.type !== 'PlayListDesktop'? item.name : fullNameOfDesktopPlaylist(item)}}
</template>

<script>
import MediumIcon from './MediumIcon'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'

export default {
  props: {
    'items': {
      required: true
    },
    showThumbs: {
      required: false,
      default: () => {
        return false
      }
    },
    showMediaIcons: {
      required: false,
      default: () => {
        return false
      }
    }
  },
  components: {
    MediumIcon
  },
  mixins: [
    mediaUtils,
    textUtils
  ],
  created () {
    this.selectedItems = JSON.parse(JSON.stringify(this.items))
  },
  watch: {
    items: async function (newVal, oldVal) {
      this.selectedItems = JSON.parse(JSON.stringify(this.items))
    },
    selectedItems: async function (newVal, oldVal) {
      this.$emit('selectedItemsChanged', this.selectedItems)
    }
  },
  data () {
    return {
      errors: {},
      selectedItems: []
    }
  },
  methods: {
    method (params) {
    },
    isSelected (item) {
      return this.selectedItems.findIndex(is => is.id === item.id) > -1
    },
    toggleItemInSelected (item) {
      const itemInSelectedIndex = this.selectedItems.findIndex(is => is.id === item.id)
      if (this.selectedItems.length === this.items.length) {
        this.selectedItems = []
        this.selectedItems.push(item)
        return
      }
      if (itemInSelectedIndex > -1) {
        this.selectedItems.splice(itemInSelectedIndex, 1)
      } else {
        this.selectedItems.push(item)
      }
    }
  },
  computed: {
    sortedItems () {
      return this.items.slice().sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .container {
    display: flex;
    flex-direction: column;
    .row {
      padding: 10px 10px;
      border-bottom:  $--border-light;
      cursor: pointer;
      color: $--color-text-secondary;
      font-size: $--font-size-small;
      display: flex;
      align-items: center;
      &.selected {
        font-weight: bold;
        color: $--color-text-primary;
        background-color:  $--background-color-selected;
      }
      .medium-name {
        max-width: 100%;
        overflow: hidden;
      }
      .img-container {
        width: 60px;
        .thumbnail {
          max-width: 30px;
          max-height: 30px;
        }
      }
      .icon {
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Common/ShortMediaList.vue